// extracted by mini-css-extract-plugin
module.exports = {"container":"CallAgenda_container__2Hal_","item":"CallAgenda_item__K7JlJ"};